import React, { ChangeEvent, ReactChild } from 'react';

type Props = {
  label: string; // Single Game Tickets
  value: string; // single
  name: string; // learnMore
  traitVals: Array<string>; // [ single, flex, group, premier, nopurchase ]
  changeHandler: (traitName: string, traitVals: Array<string>) => void;
  children?: ReactChild;
}

const SthCheckBox = ({
  label,
  value,
  name,
  traitVals,
  changeHandler,
  children,
}: Props) => {

  const handleCheckChange: (event: ChangeEvent<HTMLInputElement>) => void =
    (event: ChangeEvent<HTMLInputElement>): void => {
      event.persist();
      // this handler is invoked 2x per checked event...wth
      const traitValsCopy = [...traitVals]
      const index: number = traitValsCopy.indexOf(event.target.name);
      if (event.target.checked) {
        if (index < 0) {
          traitValsCopy.push(event.target.name);
        } else {
          return; // already pushed to array
        }
      } else {
        if (index >= 0) {
          traitValsCopy.splice(index, 1);
        } else {
          return;  // already removed from array
        }
      }
      changeHandler(name, traitValsCopy);
    };

  return (
    <div>
      <input
        type="checkbox"
        id={ value }
        name={ value }
        checked={ traitVals && traitVals.includes(value) }
        onChange={ handleCheckChange }
      />
      <label htmlFor={ value }>{ label }</label>
      {children}
    </div>
  );

};

export default SthCheckBox;
